// import { usePageTitle } from "../hooks/usePageTitle.jsx";
// import UnderPrepare from "../components/underPrepare.jsx"
import { Link } from "react-router-dom";
import OffersampleImg from "../assets/defaults/OffersSample.jpg";
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from "react";
import formatTitleForUrl from '../utilities/formatTitleForUrl';
import Pagination from '../utilities/Pagination';
import { useMetadata } from "../hooks/useMetadata";

export default function Offers() {
    const [offersData, setOffersData] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [error, setError] = useState(null);

    const { t, i18n } = useTranslation();
    const totalPages = offersData?.data?.data?.paginationInfo.totalPagesCount;

    // usePageTitle('Offer');
    useMetadata(i18n.language);

    useEffect(() => {
        async function fetchOffers() {
            try {
                const data = await fetch(`${process.env.REACT_APP_MASAR_API_URL}/offers?page=${currentPage}&limit=8`, {
                    method: "GET",
                    headers: {
                        "accept": "*/*"
                    },
                    body: JSON.stringify()
                });
                const responseData = await data.json();
                setOffersData(responseData);
            } catch (err) {
                setError(t("errorGetData"));
            }
        }

        fetchOffers();
    }, [currentPage, t]);

    if (error) {
        return <div className="text-center my-4 text-danger">{error}</div>;
    }

    if (!offersData) {
        return <div className="loader" role="status" aria-live="polite" aria-label="Loading"></div>;
    }

    if (offersData?.data?.data?.result.length === 0) {
        return (i18n.language === "ar" ?
            <p className="text-center my-3 mx-auto rounded p-2 bg-light-beige text-white w-75">  ستجد العديد من العروض هنا قريبا</p> :
            <p className="text-center my-3 mx-auto rounded p-2 bg-light-beige text-white w-75">You will find many offers here soon</p>);
    }


    return (
        <div className="container mt-4">
            <div className="d-flex flex-wrap justify-content-evenly pt-1 align-content-start">
                {offersData?.data?.data?.result.map((offer) => (
                    <div key={offer.id} className="admin-profile-img col-12 col-md-4 col-lg-3 p-1 position-relative p-3">
                        <p className="position-absolute bottom-0 start-50 mb-4 p-2 translate-middle-x bg-white w-75 text-center rounded rounded-1">
                            {i18n.language === "ar" ? offer.nameAr : offer.nameEn}
                        </p>
                        <Link to={`/${i18n.language}/offers/${offer.id}/${formatTitleForUrl(i18n.language === "ar" ? offer.nameAr : offer.nameEn)}`} key={offer.id} className="text-decoration-none">
                            <img
                                crossOrigin="anonymous"
                                src={offer.image ? offer.image : OffersampleImg}
                                alt={`Offer ${offer.id}`}
                                className="rounded-4 w-100 border" />

                        </Link>
                    </div>
                ))}
            </div>
            {totalPages > 1 &&
                <Pagination
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                    totalPages={totalPages} />
            }
        </div>
    );
};

// {/* <UnderPrepare /> */}